// Modules
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { ShareButtons, generateShareIcon } from 'react-share';
import { CopyToClipboard } from 'react-copy-to-clipboard';
// Helper
import { trackEvent } from '../../utils/analytics/analyticsManager';
// Constants
import { eventCategory, eventAction, eventLabel } from '../../utils/analytics/analyticsConstants';
// Styles
import * as styles from './ShareButtonsRow.scss';

const FacebookIcon = generateShareIcon('facebook');
const WhatsappIcon = generateShareIcon('whatsapp');
const { FacebookShareButton } = ShareButtons;

export default class ShareButtonsRow extends Component {
  state = {
    linkCopied: false,
    isShowShare: false
  };

  trackShareClick = () =>
    new Promise((resolve) => {
      resolve(trackEvent(eventCategory.share, eventAction.click, eventLabel.contactDetails));
    });


  handleCopyLink = () => {
    this.setState({ linkCopied: true });
  };

  handleOpenShare = () => {
    if (navigator.share) {
      const { sharingData } = this.props;
      navigator.share({
        url: sharingData.sharingUrl,
        title: sharingData.sharingTitle || undefined
      });
      return;
    }
    this.setState((prevState) => ({ isShowShare: !prevState.isShowShare }));
  };

  handleClickNativeLink = () => {
    const { isNative, sharingData: { sharingUrl } } = this.props;
    const protocol = (sharingUrl.includes('://')) ? '' : 'https://';

    if (!isNative) {
      return;
    }

    if (window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
      window.ReactNativeWebView.postMessage(JSON.stringify({
        type: 'share',
        url: `${protocol}${sharingUrl}`
      }));
    } else {
      console.warn('ReactNativeWebView is not available');
    }
  };

  renderShareEmail = (sharingUrl, sharingTitle) => {
    const link = `mailto:?subject=${sharingTitle}&body=${sharingTitle} ${sharingUrl}`;

    return (
      <a href={link} className={styles.shareRow}>
        <div className={styles.iconWrapper}>
          <span className="icon icon-mailIcon" />
        </div>

        {!this.props.isMobile && <span>Email</span>}
      </a>
    );
  };

  renderShouldCopyButton = () => (
    <div className={styles.copyLinkWrap}>
      <span className="icon icon-copy-link">
        <span className="path1" />
        <span className="path2" />
        <span className="path3" />
      </span>
    </div>
  );

  renderCopiedButton = () => (
    <span className="icon icon-circled-check" >
      <span className="path1" />
      <span className="path2" />
    </span>
  );

  renderShareIcon = (shareTitle) => {
    const { isShowShare } = this.state;
    const { isNative } = this.props;

    return (
      <div className={styles.shareIcon} onClick={!isNative && this.handleOpenShare}>
        {isNative && (
          <span
            onClick={this.handleClickNativeLink}
            className={styles.phoneNative}
          >
            <span className="icon icon-contacts-share-fill" />
            <span>{shareTitle}</span>
          </span>
        )}
        {!isNative && <span className="icon icon-contacts-share-fill" />}
        {!isNative && <span>{shareTitle}{isShowShare ? ':' : ''}</span>}
      </div>
    );
  }

  render() {
    const { sharingData: { sharingUrl, sharingTitle }, isMobile, shareTitle } = this.props;
    const { isShowShare } = this.state;

    const protocol = (sharingUrl.includes('://')) ? '' : 'https://';
    const shareText = `${encodeURIComponent(sharingTitle)} ${protocol}${sharingUrl}`;
    const whatsappLink = isMobile
      ? `whatsapp://send?text=${shareText}`
      : `https://api.whatsapp.com/send?text=${shareText}`;

    const iconSize = isMobile ? 40 : 50;

    return (
      <div
        className={cx(styles.wrapper, styles[this.props.className])}
      >
        <div>
          {this.renderShareIcon(shareTitle)}
          <div className={styles.shareBlock}>
            <div className={
              cx(styles.shareWrapper, {
                [styles.shareOpenWrapper]: isShowShare
              })}
            >
              <div className={styles.shareRow}>
                <FacebookShareButton
                  url={protocol + sharingUrl}
                  beforeOnClick={this.trackShareClick}
                >
                  <div className={styles.iconWrapper}>
                    <FacebookIcon size={iconSize} round />
                  </div>
                  {!isMobile && <span>Facebook</span>}
                </FacebookShareButton>
              </div>
              <a
                className={styles.shareRow}
                href={whatsappLink}
                target="_blank"
                data-action="share/whatsapp/share"
              >
                <div className={styles.iconWrapper}>
                  <WhatsappIcon size={iconSize} round />
                </div>
                {!isMobile && <span> WhatsApp</span>}
              </a>

              <CopyToClipboard
                text={sharingUrl && sharingUrl.replace(/www./g, '')}
                onCopy={this.handleCopyLink}
              >
                <div className={styles.shareRow}>
                  <div className={styles.iconWrapper}>
                    {this.state.linkCopied ? this.renderCopiedButton() : this.renderShouldCopyButton()}
                  </div>
                  {!isMobile && (
                    <div className={styles.copyLink}>
                      <span>{this.props.copyLinkTitle}</span>
                    </div>
                  )}
                </div>
              </CopyToClipboard>

              {this.renderShareEmail(`${protocol}${sharingUrl}`, sharingTitle)}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ShareButtonsRow.propTypes = {
  shareProperties: PropTypes.object,
  className: PropTypes.string,
  shareTitle: PropTypes.string,
  copyLinkTitle: PropTypes.string,
  sharingData: PropTypes.object,
  hideTooltip: PropTypes.func,
  isTooltipShown: PropTypes.bool,
  isMobile: PropTypes.bool,
  isNative: PropTypes.bool,
  locale: PropTypes.string
};
